<template>
    <div class="w-full font-sans">
        <div
            class="flex w-full flex-col items-start gap-[24px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-[#F4F5F7] p-[21px]"
        >
            <div
                class="grid w-full grid-cols-2 gap-[24px] max-[860px]:grid-cols-1"
            >
                <div class="kv">
                    <div
                        class="text-[10.5px] font-[500] leading-[14.91px] text-[#9FA6B2]"
                    >
                        {{ $t("vue.record_type") }}
                    </div>
                    <div
                        class="mt-[6px] text-[12.75px] font-[400] leading-[14.91px] text-[#161E2E]"
                    >
                        TXT
                    </div>
                </div>
                <div class="kv">
                    <div
                        class="text-[10.5px] font-[500] leading-[14.91px] text-[#9FA6B2]"
                    >
                        {{ $t("vue.host_name") }}
                    </div>
                    <div
                        class="mt-[6px] text-[12.75px] font-[400] leading-[14.91px] text-[#161E2E]"
                    >
                        {{ hostName }}
                    </div>
                </div>
            </div>

            <div class="w-full">
                <div
                    class="text-[10.5px] font-[500] leading-[14.91px] text-[#9FA6B2]"
                >
                    {{ $t("vue.value") }}
                </div>
                <div class="relative mt-[6px]">
                    <textarea
                        v-model="record"
                        class="w-full border-0 bg-transparent p-0 pr-[24px] text-[12.75px] font-[400] leading-[14.91px] text-[#161E2E] outline-none"
                        rows="5"
                        spellcheck="false"
                        :aria-label="$t('vue.dmarc_record_aria_value')"
                        @blur="normalizeRecord"
                    />
                    <button
                        class="absolute right-0 top-[2px] grid h-[14px] w-[14px] cursor-pointer place-items-center border-0 bg-transparent p-0"
                        type="button"
                        :aria-label="$t('vue.dmarc_record_aria_copy')"
                        @click="copy"
                    >
                        <span
                            class="block h-[14px] w-[14px] [&>svg]:h-[14px] [&>svg]:w-[14px]"
                            v-html="copySvg"
                        />
                    </button>
                </div>
            </div>

            <button
                class="inline-flex cursor-pointer items-center gap-[3.65px] text-[10.5px] font-[500] leading-[14.91px] text-[#088BEA] underline [text-decoration-skip-ink:auto] [text-decoration-style:solid] [text-decoration-thickness:auto] [text-underline-offset:auto] [text-underline-position:from-font] hover:text-[#0679CC]"
                type="button"
                @click="open = !open"
            >
                {{
                    open
                        ? $t("vue.hide_record_settings")
                        : $t("vue.show_record_settings")
                }}
                <component
                    :is="open ? ChevronUp : ChevronDown"
                    class="h-[14px] w-[9px]"
                />
            </button>

            <div v-show="open" class="mt-[24px] grid gap-[24px]">
                <div
                    class="grid grid-cols-[repeat(3,minmax(220px,1fr))] gap-[15px] max-[860px]:grid-cols-1"
                >
                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_policy_label") }}
                        </div>
                        <select
                            v-model="ui.p"
                            class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                        >
                            <option value="none">
                                {{ $t("vue.dmarc_record_option_none_monitor") }}
                            </option>
                            <option value="quarantine">
                                {{ $t("vue.dmarc_record_option_quarantine") }}
                            </option>
                            <option value="reject">
                                {{ $t("vue.dmarc_record_option_reject") }}
                            </option>
                        </select>
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_policy_hint") }}
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_pct_label") }}
                        </div>
                        <div class="relative">
                            <input
                                v-model="ui.pct"
                                class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                            />
                            <!--                        <span-->
                            <!--                            class="absolute right-[10px] top-[8px] text-[12px] font-[500] leading-[16.8px] text-[#9FA6B2]"-->
                            <!--                            >%</span-->
                            <!--                        >-->
                        </div>
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_pct_hint") }}
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_ri_label") }}
                        </div>
                        <input
                            v-model="ui.ri"
                            class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                            type="number"
                            min="0"
                            step="1"
                        />
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_ri_hint") }}
                        </div>
                    </div>
                </div>

                <div
                    class="grid grid-cols-[repeat(3,minmax(220px,1fr))] gap-[15px] max-[860px]:grid-cols-1"
                >
                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_adkim_label") }}
                        </div>
                        <select
                            v-model="ui.adkimMode"
                            class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                        >
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="r">
                                {{ $t("vue.dmarc_record_option_relaxed") }}
                            </option>
                            <option value="s">
                                {{ $t("vue.dmarc_record_option_strict") }}
                            </option>
                        </select>
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_alignment_hint") }}
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_aspf_label") }}
                        </div>
                        <select
                            v-model="ui.aspfMode"
                            class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                        >
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="r">
                                {{ $t("vue.dmarc_record_option_relaxed") }}
                            </option>
                            <option value="s">
                                {{ $t("vue.dmarc_record_option_strict") }}
                            </option>
                        </select>
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_alignment_hint") }}
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div
                            class="mb-[6px] text-[12px] font-[500] leading-[16.8px] text-[#000000]"
                        >
                            {{ $t("vue.dmarc_record_fo_label") }}
                        </div>
                        <select
                            v-model="ui.fo"
                            class="h-[36px] w-[200px] rounded-[8px] border-[1px] border-[#E5E7EB] bg-white px-[10px] py-[8px] text-[12px] font-[400] leading-[16.8px] text-[#161E2E] outline-none"
                        >
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="0">
                                {{ $t("vue.dmarc_record_option_fo_all") }}
                            </option>
                            <option value="1">
                                {{ $t("vue.dmarc_record_option_fo_any") }}
                            </option>
                            <option value="d">
                                {{ $t("vue.dmarc_record_option_fo_dkim") }}
                            </option>
                            <option value="s">
                                {{ $t("vue.dmarc_record_option_fo_spf") }}
                            </option>
                            <option
                                v-for="opt in foComboOptions"
                                :key="opt"
                                :value="opt"
                            >
                                {{ opt }}
                            </option>
                        </select>
                        <div
                            class="mt-[6px] text-[10px] font-[400] leading-[14.2px] text-[#9FA6B2]"
                        >
                            {{ $t("vue.dmarc_record_fo_hint") }}
                        </div>
                    </div>
                </div>

                <!--
                    Hidden per design: Reporting / Advanced / Status / Extras.
                    Keep the markup for later reuse after management review.
                <div class="adv-title">
                    {{ $t("vue.dmarc_record_reporting_title") }}
                </div>
                <div class="grid-2">
                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_rua_label") }}
                        </div>
                        <textarea
                            v-model="ui.rua"
                            class="control ta"
                            rows="3"
                            spellcheck="false"
                            :placeholder="$t('vue.dmarc_record_placeholder_mailto')"
                        />
                        <div class="hint">
                            {{ $t("vue.dmarc_record_rua_hint") }}
                        </div>
                    </div>

                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_ruf_label") }}
                        </div>
                        <textarea
                            v-model="ui.ruf"
                            class="control ta"
                            rows="3"
                            spellcheck="false"
                            :placeholder="$t('vue.dmarc_record_placeholder_mailto')"
                        />
                        <div class="hint">
                            {{ $t("vue.dmarc_record_ruf_hint") }}
                        </div>
                    </div>
                </div>

                <div class="adv-title">
                    {{ $t("vue.dmarc_record_advanced_title") }}
                </div>
                <div class="grid-3">
                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_sp_label") }}
                        </div>
                        <select v-model="ui.sp" class="control">
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="none">
                                {{ $t("vue.dmarc_record_option_none_monitor") }}
                            </option>
                            <option value="quarantine">
                                {{ $t("vue.dmarc_record_option_quarantine") }}
                            </option>
                            <option value="reject">
                                {{ $t("vue.dmarc_record_option_reject") }}
                            </option>
                        </select>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_sp_hint") }}
                        </div>
                    </div>

                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_np_label") }}
                        </div>
                        <select v-model="ui.np" class="control">
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="none">
                                {{ $t("vue.dmarc_record_option_none_monitor") }}
                            </option>
                            <option value="quarantine">
                                {{ $t("vue.dmarc_record_option_quarantine") }}
                            </option>
                            <option value="reject">
                                {{ $t("vue.dmarc_record_option_reject") }}
                            </option>
                        </select>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_np_hint") }}
                        </div>
                    </div>

                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_rf_label") }}
                        </div>
                        <select v-model="ui.rf" class="control">
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="afrf">afrf</option>
                        </select>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_rf_hint") }}
                        </div>
                    </div>
                </div>

                <div class="grid-3">
                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_psd_label") }}
                        </div>
                        <select v-model="ui.psd" class="control">
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="y">y</option>
                            <option value="n">n</option>
                        </select>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_psd_hint") }}
                        </div>
                    </div>

                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_t_label") }}
                        </div>
                        <select v-model="ui.t" class="control">
                            <option value="">
                                {{ $t("vue.dmarc_record_option_not_set") }}
                            </option>
                            <option value="y">y</option>
                        </select>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_t_hint") }}
                        </div>
                    </div>

                    <div class="field">
                        <div class="title">
                            {{ $t("vue.dmarc_record_status_label") }}
                        </div>
                        <div class="status-pill" :class="{ ok: isDmarc }">
                            {{
                                isDmarc
                                    ? $t("vue.dmarc_record_status_detected")
                                    : $t("vue.dmarc_record_status_waiting")
                            }}
                        </div>
                        <div class="hint">
                            {{ $t("vue.dmarc_record_status_hint") }}
                        </div>
                    </div>
                </div>

                <div v-if="extras.length" class="extras">
                    <div class="extras-title">
                        {{ $t("vue.dmarc_record_extras_title") }}
                    </div>
                    <div class="extras-body">
                        <code v-for="(x, i) in extras" :key="i"
                            >{{ x.k }}={{ x.v }}</code
                        >
                    </div>
                </div>
                -->
            </div>
        </div>

        <div
            v-if="toast"
            class="fixed bottom-[18px] right-[18px] rounded-[8px] bg-[#161E2E] px-[10px] py-[8px] text-[12px] text-white"
        >
            {{ toast }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, ref, watch } from "vue";
import { useTranslations } from "@/composables/useTranslations";
import { ChevronDown, ChevronUp } from "lucide-vue-next";

const props = defineProps({
    hostName: { type: String, default: "_dmarc" },
    modelValue: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);
const { t } = useTranslations();

const policyVals = new Set(["none", "quarantine", "reject"]);
const alignVals = new Set(["r", "s"]);
const knownKeys = new Set([
    "p",
    "sp",
    "np",
    "adkim",
    "aspf",
    "pct",
    "ri",
    "rf",
    "rua",
    "ruf",
    "fo",
    "psd",
    "t",
]);

const norm = (s) => (s ?? "").trim();
const splitParts = (txt) =>
    norm(txt)
        .split(";")
        .map((x) => x.trim())
        .filter(Boolean);

const toIntStr = (v, fallback) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return String(fallback);
    return String(Math.max(0, Math.round(n)));
};

const pctNorm = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return "100";
    return String(Math.min(100, Math.max(0, Math.round(n))));
};

const foNormalize = (v) => {
    const s = norm(v);
    if (!s) return "";
    const parts = s
        .split(":")
        .map((x) => x.trim().toLowerCase())
        .filter(Boolean);
    const allowed = new Set(["0", "1", "d", "s"]);
    const uniq = [];
    for (const p of parts)
        if (allowed.has(p) && !uniq.includes(p)) uniq.push(p);
    if (!uniq.length) return "";
    const order = ["0", "1", "d", "s"];
    uniq.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    return uniq.join(":");
};

const ynNorm = (v) => {
    const s = norm(v).toLowerCase();
    if (s === "y" || s === "n") return s;
    return "";
};

const tNorm = (v) => (norm(v).toLowerCase() === "y" ? "y" : "");
const rfNorm = (v) => (norm(v).toLowerCase() === "afrf" ? "afrf" : "");

const foComboOptions = (() => {
    const base = ["0", "1", "d", "s"];
    const out = [];
    for (let mask = 1; mask < 1 << base.length; mask++) {
        const parts = [];
        for (let i = 0; i < base.length; i++)
            if (mask & (1 << i)) parts.push(base[i]);
        const v = parts.join(":");
        if (v.includes(":")) out.push(v);
    }
    return out;
})();

const parseDmarc = (txt) => {
    const parts = splitParts(txt);
    const tags = [];
    let isDmarc = false;

    for (const part of parts) {
        const i = part.indexOf("=");
        if (i <= 0) continue;
        const k = part.slice(0, i).trim().toLowerCase();
        const v = part.slice(i + 1).trim();

        if (k === "v") {
            isDmarc = /^dmarc1$/i.test(v);
            continue;
        }

        tags.push({ k, v });
    }

    const map = new Map();
    for (const t of tags) map.set(t.k, t.v);

    const pRaw = norm(map.get("p")).toLowerCase();
    const spRaw = norm(map.get("sp")).toLowerCase();
    const npRaw = norm(map.get("np")).toLowerCase();

    const known = {
        p: policyVals.has(pRaw) ? pRaw : "none",
        sp: policyVals.has(spRaw) ? spRaw : "",
        np: policyVals.has(npRaw) ? npRaw : "",
        pct: pctNorm(map.get("pct") ?? 100),
        ri: toIntStr(map.get("ri") ?? "86400", 86400),
        adkim: alignVals.has(norm(map.get("adkim")).toLowerCase())
            ? norm(map.get("adkim")).toLowerCase()
            : "",
        aspf: alignVals.has(norm(map.get("aspf")).toLowerCase())
            ? norm(map.get("aspf")).toLowerCase()
            : "",
        rua: map.get("rua") ?? "",
        ruf: map.get("ruf") ?? "",
        fo: foNormalize(map.get("fo") ?? ""),
        rf: rfNorm(map.get("rf") ?? ""),
        psd: ynNorm(map.get("psd") ?? ""),
        t: tNorm(map.get("t") ?? ""),
    };

    const extras = tags.filter((t) => !knownKeys.has(t.k));

    return { isDmarc, known, extras };
};

const buildDmarc = ({ known, extras }) => {
    const p = policyVals.has(known.p) ? known.p : "none";
    const sp = policyVals.has(known.sp) ? known.sp : "";
    const np = policyVals.has(known.np) ? known.np : "";
    const pct = pctNorm(known.pct);
    const ri = toIntStr(known.ri, 86400);
    const adkim = known.adkim === "s" ? "s" : known.adkim === "r" ? "r" : "";
    const aspf = known.aspf === "s" ? "s" : known.aspf === "r" ? "r" : "";
    const rua = norm(known.rua);
    const ruf = norm(known.ruf);
    const fo = foNormalize(known.fo);
    const rf = rfNorm(known.rf);
    const psd = ynNorm(known.psd);
    const t = tNorm(known.t);

    const tags = ["v=DMARC1", `p=${p}`];

    if (rua) tags.push(`rua=${rua}`);

    if (adkim) tags.push(`adkim=${adkim}`);
    if (aspf) tags.push(`aspf=${aspf}`);

    if (fo) tags.push(`fo=${fo}`);
    if (ri !== "86400") tags.push(`ri=${ri}`);
    if (pct !== "100") tags.push(`pct=${pct}`);

    if (sp) tags.push(`sp=${sp}`);
    if (np) tags.push(`np=${np}`);

    if (ruf) tags.push(`ruf=${ruf}`);
    if (rf) tags.push(`rf=${rf}`);
    if (psd) tags.push(`psd=${psd}`);
    if (t) tags.push(`t=${t}`);

    for (const x of extras) {
        if (!x?.k) continue;
        tags.push(`${x.k}=${x.v ?? ""}`);
    }

    return tags.join("; ") + ";";
};

const open = ref(false);

const ui = reactive({
    p: "none",
    pct: "100",
    ri: "86400",
    adkimMode: "",
    aspfMode: "",
    fo: "",
    rua: "",
    ruf: "",
    sp: "",
    np: "",
    rf: "",
    psd: "",
    t: "",
});

const extras = ref([]);
const record = ref("");

const isDmarc = computed(() => parseDmarc(record.value).isDmarc);

const toKnownFromUi = () => ({
    p: ui.p,
    pct: ui.pct,
    ri: ui.ri,
    adkim: ui.adkimMode,
    aspf: ui.aspfMode,
    fo: ui.fo,
    rua: ui.rua,
    ruf: ui.ruf,
    sp: ui.sp,
    np: ui.np,
    rf: ui.rf,
    psd: ui.psd,
    t: ui.t,
});

const applyKnownToUi = (known) => {
    ui.p = known.p;
    ui.pct = known.pct;
    ui.ri = known.ri;
    ui.adkimMode = known.adkim;
    ui.aspfMode = known.aspf;
    ui.fo = known.fo;
    ui.rua = known.rua;
    ui.ruf = known.ruf;
    ui.sp = known.sp;
    ui.np = known.np;
    ui.rf = known.rf;
    ui.psd = known.psd;
    ui.t = known.t;
};

let syncing = false;

watch(
    () => props.modelValue,
    (v) => {
        if (syncing) return;
        syncing = true;
        record.value = v?.trim()
            ? v
            : buildDmarc({ known: toKnownFromUi(), extras: extras.value });
        const parsed = parseDmarc(record.value);
        if (parsed.isDmarc) {
            applyKnownToUi(parsed.known);
            extras.value = parsed.extras;
        }
        syncing = false;
    },
    { immediate: true },
);

watch(
    () => ({ ...ui }),
    () => {
        if (syncing) return;
        syncing = true;
        record.value = buildDmarc({
            known: toKnownFromUi(),
            extras: extras.value,
        });
        emit("update:modelValue", record.value);
        syncing = false;
    },
    { deep: true, flush: "sync" },
);

watch(
    record,
    (v) => {
        if (syncing) return;
        const parsed = parseDmarc(v);
        if (!parsed.isDmarc) {
            emit("update:modelValue", v);
            return;
        }

        syncing = true;
        applyKnownToUi(parsed.known);
        extras.value = parsed.extras;
        emit("update:modelValue", v);
        syncing = false;
    },
    { flush: "sync" },
);

const normalizeRecord = () => {
    const parsed = parseDmarc(record.value);
    if (!parsed.isDmarc) return;
    syncing = true;
    applyKnownToUi(parsed.known);
    extras.value = parsed.extras;
    record.value = buildDmarc({ known: toKnownFromUi(), extras: extras.value });
    emit("update:modelValue", record.value);
    syncing = false;
};

const toast = ref("");

const copy = async () => {
    const txt = record.value;
    try {
        await navigator.clipboard.writeText(txt);
        toast.value = t("vue.dmarc_record_toast_copied");
    } catch {
        const ta = document.createElement("textarea");
        ta.value = txt;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast.value = t("vue.dmarc_record_toast_copied");
    } finally {
        setTimeout(() => (toast.value = ""), 1200);
    }
};

const copySvg = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_6080_23041)"><path d="M12.9655 0H5.22677C4.67523 0 4.22656 0.4487 4.22656 1.00021V3.34777H5.13961V1.00021C5.13961 0.952152 5.17871 0.913043 5.22677 0.913043H12.9655C13.0135 0.913043 13.0526 0.952152 13.0526 1.00021V8.73892C13.0526 8.78701 13.0135 8.82612 12.9655 8.82612H10.6911V9.73916H12.9655C13.517 9.73916 13.9657 9.29046 13.9657 8.73892V1.00021C13.9657 0.4487 13.517 0 12.9655 0Z" fill="#161E2E"/><path d="M8.77408 4.26074H1.0354C0.483856 4.26074 0.0351562 4.70944 0.0351562 5.26098V12.9997C0.0351867 13.5512 0.483856 13.9999 1.0354 13.9999H8.77411C9.32565 13.9999 9.77435 13.5512 9.77435 12.9997V5.26098C9.77438 4.70944 9.32562 4.26074 8.77408 4.26074ZM8.77414 13.0869H1.0354C0.987308 13.0869 0.9482 13.0478 0.9482 12.9997V5.26098C0.9482 5.21289 0.987308 5.17379 1.0354 5.17379H8.77411C8.82219 5.17379 8.8613 5.21289 8.8613 5.26098V12.9997H8.86133C8.86133 13.0478 8.8222 13.0869 8.77414 13.0869Z" fill="#161E2E"/></g><defs><clipPath id="clip0_6080_23041"><rect width="14" height="14" fill="white"/></clipPath></defs></svg>`;
</script>
